




























































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";

import { bus } from "@/pages/transitweb/main";

import VuePlotly from "@statnett/vue-plotly";

import { mixins } from "vue-class-component";
import QueryEndpointData from "./dataquery-mixin";

import BorderCrossingsBarChart from "./BorderCrossingsBarChart.vue";
import Metrics from "./Metrics.vue";
import MetricsHistogram from "./MetricsHistogram.vue";
import ModeShareBarChart from "./ModeShareBarChart.vue";
import { eventLoading } from "@/components/sce/EventLoading"; // This class controls loading state to update progress bar

@Component({
    components: {
        VuePlotly,
        Metrics,
        MetricsHistogram,
        BorderCrossingsBarChart,
        ModeShareBarChart,
    },
})
export default class SCEMap extends mixins(QueryEndpointData) {
    @Prop() spatial_type_value!: string;
    @Prop() lga_items!: string[];
    /* NOTE: TraNSIT Web is still using the 2016 LGA boundaries dataset. The trasce is
    using LGA 2023 dataset. A team decision will need to be made on what dataset to use.*/
    @Prop() state_items!: string[];
    @Prop() spatialBorderCrossing!: boolean;
    /** Shared colour-scale range across all four sibling SCEMaps for the
     *  current metric. Computed in SupplyChainExplorer from each map's
     *  `data-range-changed` emit. `null` falls back to Plotly's
     *  per-map autoscale (initial render before any sibling has reported,
     *  and for the percent metric which uses a fixed log scale anyway). */
    @Prop({ default: () => null }) globalRange!: {
        min: number;
        max: number;
    } | null;

    histogramVisible = false;
    selectedMetricTitle = "";
    selectedMetric: any = null;
    mapboxAccessToken =
        "pk.eyJ1IjoiYm9uMTMyIiwiYSI6ImNqdXRhYmw1OTA1eGUzeW5yZGo3OWZmankifQ.RYbaSeGdz3Nq_hIGWXrpSw";

    get densityMapUrl() {
        return process.env.VUE_APP_BACKEND_BASE + "/supplychainexplorer/map";
    }

    mounted() {
        this.loadData(this.densityMapUrl);
    }

    created() {
        eventLoading.$on("loading", this.setLoading);
    }

    beforeDestroy() {
        eventLoading.$off("loading", this.setLoading);
    }

    setLoading(isLoading: boolean) {
        this.loading = isLoading;
    }

    @Watch("updateRequired")
    reloadData(newVal: any, oldVal: any) {
        this.loadData(this.densityMapUrl);
    }

    /** Emit the raw min / max of the current metric for this map every
     *  time the underlying data changes. The parent aggregates across the
     *  four sibling maps so they end up sharing the same colour scale,
     *  which is what makes side-by-side comparison meaningful. */
    @Watch("data")
    @Watch("metric")
    onDataRangeChanged() {
        let min = Infinity;
        let max = -Infinity;
        for (const row of this.data) {
            const v = row[this.metric.value];
            if (v == null || !Number.isFinite(v)) continue;
            if (v < min) min = v;
            if (v > max) max = v;
        }
        const ok = Number.isFinite(min) && Number.isFinite(max);
        this.$emit("data-range-changed", {
            map_id: this.config.map_id,
            min: ok ? min : null,
            max: ok ? max : null,
        });
    }

    ask_assistant() {
        var question = this.create_question();
        bus.$emit("assistant", { content: question });
    }

    create_question() {
        // Build a question  for the assistant
        var question = `Please tell me about the supply chain movements of ${this.commodity}`;

        if (this.spatial_selection.length > 0) {
            // If there was a spatial filter add in the region anf the filtered leg of the supply chain.
            var regions: string[] = [];

            if (this.spatial_type_value === "lga") {
                regions = this.lga_items
                    .filter((item: any) =>
                        this.spatial_selection.includes(item.code),
                    )
                    .map((item: any) => item.name);
            } else if (this.spatial_type_value === "state") {
                regions = this.state_items
                    .filter((item: any) =>
                        this.spatial_selection.includes(item.code),
                    )
                    .map((item: any) => item.name);
            }

            var region = regions.join(", ");

            var direction =
                this.supply_chain_leg_direction(this.supply_chain_leg) == "orig"
                    ? "originating from"
                    : "destined to";
            question = question.concat(
                ` related to ${this.supply_chain_leg.replace(
                    "_",
                    " & ",
                )} ${direction} ${region}. `,
            );
        } else {
            // Ask about all of australia.
            question = question.concat(` across Australia. `);
        }

        // Add some context for the the supply chain leg map which was honked.
        question = question.concat(
            `I am particularly interested in the specific enterprise regions that the commodity travels ${
                this.config.direction
            } which have a key role in the ${this.config.title.toLowerCase()} part of the supply chain. `,
        );
        return question;
    }

    get mapData() {
        var region_items =
            this.spatial_type_value == "lga"
                ? this.lga_items
                : this.state_items;
        var regionItemNameLookup = new Map(
            region_items.map((item: any) => [item.code, item.name]),
        );

        // Get the plotly data object for the appropriate supply chain leg map.
        if (["node", "lga", "state"].includes(this.metric.value)) {
            return [
                {
                    type: "choroplethmapbox",
                    name: this.spatial_type.text,
                    geojson: this.spatial_type.geojson,
                    locations: this.data.map((item: any) => item[this.regions]),
                    meta: this.data.map((item: any) => item[this.metric.value]),
                    customdata: this.data.map((item: any) => {
                        var regionCode = item[this.regions];
                        var regionName =
                            regionItemNameLookup.get(regionCode) || "Unknown";
                        return [
                            this.metric.text,
                            this.config.map_id,
                            this.metric.valuesuffix,
                            regionName,
                        ];
                    }),
                    hovertemplate:
                        "%{customdata[0]}: %{meta:.0f} %{customdata[2]}<extra>%{customdata[3]}</extra>",
                    z: this.data.map((item: any) => item[this.metric.value]),
                    // Pin zmin/zmax so every map
                    // uses the same colour-to-value mapping.
                    ...(this.globalRange
                        ? {
                              zmin: this.globalRange.min,
                              zmax: this.globalRange.max,
                          }
                        : {}),
                    colorscale: [
                        [0, "#e8eaf6"], //Pale indigo
                        [0.4, "rgb(63,81,181)"], //Indigo
                        [1, "red"],
                    ], // If only one value returned, plotly puts it in the middle of the color scale instead of mapping it to the maximum color..
                    marker: { opacity: 0.65 },
                    showscale: false,
                },
            ];
        } else {
            return [
                {
                    type: "choroplethmapbox",
                    name: this.spatial_type.text,
                    geojson: this.spatial_type.geojson,
                    locations: this.data.map((item: any) => item[this.regions]),
                    meta: this.data.map((item: any) => item[this.metric.value]),
                    customdata: this.data.map((item: any) => {
                        var regionCode = item[this.regions];
                        var regionName =
                            regionItemNameLookup.get(regionCode) || "Unknown";
                        return [
                            this.metric.text,
                            this.config.map_id,
                            regionName,
                        ];
                    }),
                    hovertemplate:
                        "%{customdata[0]}: %{meta:.2%}<extra>%{customdata[2]}</extra>",
                    z: this.data.map((item: any) =>
                        Math.log10(item[this.metric.value]),
                    ),
                    zmin: -4,
                    zmax: 0,
                    colorscale: [
                        [0, "#e8eaf6"],
                        [0.4, "rgb(63,81,181)"],
                        [1, "red"],
                    ],
                    marker: { opacity: 0.65 },
                    showscale: false,
                },
            ];
        }
    }

    get mapLayout() {
        // Get the plotly layout object for the appropriate supply chain leg map.
        return {
            mapbox: {
                style: "mapbox://styles/bon132/cmm8gavux000101sjauuwfvpe",
                access_token: this.mapboxAccessToken,
                center: {
                    lon: 134,
                    lat: -28.3,
                },
                zoom: 2.7,
            },
            height: 370,
            autosize: true,
            margin: { t: 6, b: 0, l: 10, r: 10 },
        };
    }

    densityMapOnClick(e: any) {
        this.$emit("update-spatial-params", e);
    }

    hasMapData(mapData: any): boolean {
        return mapData[0]?.z?.some((v: any) => v != null);
    }

    onMetricClicked(title: string, metric: any) {
        this.selectedMetricTitle = title;
        this.selectedMetric = metric;
        this.histogramVisible = true;
    }

    get visible(): "loading" | "no-data" | "histogram" | "map" {
        if (this.loading) return "loading";
        if (!this.hasMapData(this.mapData)) return "no-data";
        if (this.histogramVisible) return "histogram";
        return "map";
    }

    onCrossingSelected(payload: { clickedValue: number; map_id: string }) {
        this.$emit("crossing-selected", payload);
    }
}
